export default __webpack_public_path__ + "static/doubleAlbert-ad863ff092db00d821d05020fc45d9d7.svg";